import styled from "styled-components";
import {WordEntry} from "../../WordEntry";
import React, {FC} from "react";

type KanjiDisplayProps = {
    entry: WordEntry
}

export const KanjiDisplay: FC<KanjiDisplayProps> = ({entry}) => {
    if(entry.kanji && entry.kanji != 'NULL') {
        return <StyledKanjiDisplay>{entry.kanji}</StyledKanjiDisplay>
    } else {
        return null;
    }
}

const StyledKanjiDisplay = styled.div`
  font-family:  ${props => props.theme.japaneseFont};
  font-size: 1.5em;
  margin-bottom: 0.3em;
  line-height: 0.8em;
`



// WEBPACK FOOTER //
// ./src/components/QuizBox/KanjiDisplay.tsx